let wishListService = {
  baseUrl: `https://newwishes.trainz.com`,  
  encryptedCustomerId: '',


  getTrainzUser: function (sourceId, customerId, customerEmail) {
    let res = null;
    return fetch(`${this.baseUrl}/api/customers/?sourceId=${sourceId}&customerId=${customerId}&email=${customerEmail}`)
      .then(response => {
        res = response.json();
        res.then(x => {
          this.encryptedCustomerId = x.result.customerId;
        });
        return res;
      }, error => { return error; });
  },

  getWishesForSkus: function (trainzCustomerId, skus) {
    return fetch(`${this.baseUrl}/api/customers/${trainzCustomerId}/wishes-for-skus`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      body: JSON.stringify(skus)
    }).then(response => { return response.json() }, error => { return error });
  },

  getWishLoggedOutUrl: function (sku) {
    let returnUrl = window.location.pathname; //.href.replace('https://www.trainz.com', '').replace('http://127.0.0.1:9292', '');
    let params = new URLSearchParams(window.location.search);
    let url = returnUrl;

    if (Array.from(params).length > 0) {
      url += `?${params.toString()}`;
    }

    url += `${Array.from(params).length > 0 ? '&' : '?'}`;
    url += `add-to-wishlist=${sku}`;
    return url;
  },

  buildProductCardWishButton: function (hasWish, sku, wishId, queryId, objectId, productId) {
    let html =
      `
      <div class='add-remove-wish-wrapper'>
        <a id='remove-wish-${sku}' href='javascript:;'  class='remove-wish ${hasWish ? '' : 'hide'}' data-sku='${sku}' data-wish-id='${hasWish ? wishId : ''}' data-product-id='${productId ? productId : ''}'>
          <div data-sku='${sku}' data-wish-id='${hasWish ? wishId : ''}' data-product-id='${productId ? productId : ''}' class="add-to-wish-icon">
            <svg data-sku='${sku}' data-wish-id='${hasWish ? wishId : ''}' data-product-id='${productId ? productId : ''}' version="1.1" xmlns="https://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
              <path data-sku='${sku}' data-wish-id='${hasWish ? wishId : ''}' data-product-id='${productId ? productId : ''}' d="M47.199 4c-6.727 0-12.516 5.472-15.198 11.188-2.684-5.715-8.474-11.188-15.201-11.188-9.274 0-16.8 7.527-16.8 16.802 0 18.865 19.031 23.812 32.001 42.464 12.26-18.536 31.999-24.2 31.999-42.464 0-9.274-7.527-16.802-16.801-16.802z" fill="#000"></path>
            </svg>
          </div>
          In Wish List
        </a>
        <a id='add-wish-${sku}' data-query-id='${queryId ? queryId : ''}' data-object-id='${objectId ? objectId : ''}' href='javascript:;' class='add-wish ${hasWish ? 'hide' : ''}' data-sku='${sku}' data-product-id='${productId ? productId : ''}'>
          <div data-sku='${sku}' data-query-id='${queryId ? queryId : ''}' data-object-id='${objectId ? objectId : ''}' data-product-id='${productId ? productId : ''}' class="add-to-wish-icon">
            <svg data-sku='${sku}' data-query-id='${queryId ? queryId : ''}' data-object-id='${objectId ? objectId : ''}' data-product-id='${productId ? productId : ''}' xmlns="http://www.w3.org/2000/svg" width="21.5" height="20.296" viewBox="0 0 21.5 20.296">
              <g data-sku='${sku}' data-query-id='${queryId ? queryId : ''}' data-object-id='${objectId ? objectId : ''}' data-product-id='${productId ? productId : ''}' id="heart" transform="translate(-47.225 -63.175)">
                <path data-sku='${sku}' data-query-id='${queryId ? queryId : ''}' data-object-id='${objectId ? objectId : ''}' data-product-id='${productId ? productId : ''}' id="Path_1" data-name="Path 1" d="M66.335,65.448a4.838,4.838,0,0,0-7.038,0l-1.322,1.37-1.322-1.375a4.838,4.838,0,0,0-7.038,0,5.993,5.993,0,0,0,0,8.239l8.36,8.706,8.36-8.7A5.993,5.993,0,0,0,66.335,65.448Z" fill="#fff" stroke="#000" stroke-width="1.5"/>
              </g>
            </svg>
          </div>
          Add To Wish List
        </a>
      </div>`;
    const fragment = document.createRange().createContextualFragment(html);
    return fragment;
  },

  buildProductDetailsWishButton: function (hasWish, sku, wishId) {
    let html =
      `<div class='product-page-wishlist-wrap'>
            <a id='remove-wish-${sku}' href='javascript:;' class='remove-wish ${hasWish ? '' : 'hide'}' data-sku='${sku}' data-wish-Id='${hasWish ? wishId : ''}' >
                <div data-sku='${sku}' data-wish-id='${hasWish ? wishId : ''}' class="add-to-wish-icon">
                    <svg data-sku='${sku}' data-wish-id='${hasWish ? wishId : ''}' version="1.1" xmlns="https://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
                        <path data-sku='${sku}' data-wish-id='${hasWish ? wishId : ''}' d="M47.199 4c-6.727 0-12.516 5.472-15.198 11.188-2.684-5.715-8.474-11.188-15.201-11.188-9.274 0-16.8 7.527-16.8 16.802 0 18.865 19.031 23.812 32.001 42.464 12.26-18.536 31.999-24.2 31.999-42.464 0-9.274-7.527-16.802-16.801-16.802z"</path>
                    </svg>
                </div>
                In Wish List
            </a>
            <a id='add-wish-${sku}' href='javascript:;' class='add-wish ${hasWish ? 'hide' : ''}' data-sku='${sku}'>
                <div data-sku='${sku}'  class="add-to-wish-icon">
                    <svg data-sku='${sku}'  xmlns="http://www.w3.org/2000/svg" width="21.5" height="20.296" viewBox="0 0 21.5 20.296">
                        <g data-sku='${sku}'  id="heart" transform="translate(-47.225 -63.175)">
                            <path data-sku='${sku}' id="Path_1" data-name="Path 1" d="M66.335,65.448a4.838,4.838,0,0,0-7.038,0l-1.322,1.37-1.322-1.375a4.838,4.838,0,0,0-7.038,0,5.993,5.993,0,0,0,0,8.239l8.36,8.706,8.36-8.7A5.993,5.993,0,0,0,66.335,65.448Z" stroke-width="1.5"/>
                        </g>
                    </svg>
                </div>
                Add To Wish List
            </a>
        </div>`;
    const fragment = document.createRange().createContextualFragment(html);
    return fragment;
  },

  buildLoggedOutWishButtonHtml: function (sku) {
    let url = this.getWishLoggedOutUrl(sku)
    let html =
      `<div class="add-remove-wish-wrapper">
            <a href="/account/login?checkout_url=${url}" class="add-wish">
              <div class="add-to-wish-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="21.5" height="20.296" viewBox="0 0 21.5 20.296">
                    <g  id="heart" transform="translate(-47.225 -63.175)">
                        <path  id="Path_1" data-name="Path 1" d="M66.335,65.448a4.838,4.838,0,0,0-7.038,0l-1.322,1.37-1.322-1.375a4.838,4.838,0,0,0-7.038,0,5.993,5.993,0,0,0,0,8.239l8.36,8.706,8.36-8.7A5.993,5.993,0,0,0,66.335,65.448Z" fill="#fff" stroke="#000" stroke-width="1.5" />
                    </g>
                </svg>          
              </div>
              Add To Wish List
            </a>
          </div>`;
    return html;
  },

  buildProductDetailsLoggedOutWishButtonHtml: function (sku) {
    let url = this.getWishLoggedOutUrl(sku)
    let html =
      `<div class="product-page-wishlist-wrap">
            <a href="/account/login?checkout_url=${url}" class="add-wish">
              <div class="add-to-wish-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="21.5" height="20.296" viewBox="0 0 21.5 20.296">
                    <g  id="heart" transform="translate(-47.225 -63.175)">
                        <path  id="Path_1" data-name="Path 1" d="M66.335,65.448a4.838,4.838,0,0,0-7.038,0l-1.322,1.37-1.322-1.375a4.838,4.838,0,0,0-7.038,0,5.993,5.993,0,0,0,0,8.239l8.36,8.706,8.36-8.7A5.993,5.993,0,0,0,66.335,65.448Z" stroke-width="1.5"/>
                    </g>
                </svg>          
              </div>
              Add To Wish List
            </a>
          </div>`;
    return html;
  },

  initWishes: function (customerId, customerEmail, skus) {
    return this.getTrainzUser(1, customerId, customerEmail)
      .then(userResponse =>
        this.getWishesForSkus(userResponse.result.customerId, skus)
          .then(response => {
            return response;
          })
          .catch(error => {
            console.error(error);
            return error;
          })
      ).catch(error => console.error(error));
  },
  removeWishAsync: async function(wishId) {
    try {
      const responseJson = await fetch(`${this.baseUrl}/api/customers/${this.encryptedCustomerId}/wishes/${wishId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      });
  
      const response = await responseJson.json();
      if(response.succeded) {
        this.decrease();
      }
    } catch (e) {
      console.error(e);
    }
  },
  addWishAsync: async function(sku) {
    try {
      const responseJson = await fetch(`${this.baseUrl}/api/customers/${this.encryptedCustomerId}/wishes`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        },
        body: JSON.stringify({ sku: sku, wishSourceId: 1 })
      });
  
      const response = await responseJson.json();
      if(response.succeded) {
        this.increase();
      }
      return response;
    } catch (e) {
      console.error(e);
    }
  },
  removeWish(e) {
    let wishId = e.target.getAttribute('data-wish-id');
    let sku = e.target.getAttribute('data-sku');

    fetch(`${this.baseUrl}/api/customers/${this.encryptedCustomerId}/wishes/${wishId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      }
    }).then(x => {
      x.json().then(response => {
        if (response.succeded) {
          this.handleRemove(sku);
          this.decrease();
          
          let otherElements = document.querySelectorAll(`a[data-wish-id="${wishId}"]`);
          if(otherElements) {
            otherElements.forEach(element => {
              let otherSku = element.getAttribute('data-sku');
              this.handleRemove(otherSku);
            });
          }
        } else {
          console.error(response);
        }
      })
    }, error => { console.error(error) })
  },

  handleRemove(sku) {
    document.querySelector(`#remove-wish-${sku}`).classList.add('hide');
    document.querySelector(`#add-wish-${sku}`).classList.remove('hide');
    document.querySelector(`#remove-wish-${sku}`).setAttribute('data-wish-id', '');

    let matches = document.querySelector(`#remove-wish-${sku}`).querySelectorAll(`[data-sku='${sku}']`);

    for (let i = 0; i < matches.length; i++) {
      matches[i].setAttribute('data-wish-id', '');
    }
  },

  addWish(sku, qId, objId, productId) {
    fetch(`${this.baseUrl}/api/customers/${this.encryptedCustomerId}/wishes`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      body: JSON.stringify({ sku: sku, wishSourceId: 1 })
    }).then(x => {
      x.json().then(response => {
        if (response.succeded) {
          this.handleAddWish(sku, response.result.wishId);
          if(productId) {
            let otherElements = document.querySelectorAll(`a[data-product-id="${productId}"]`);
            if(otherElements) {
              otherElements.forEach(element => {
                let otherSku = element.getAttribute('data-sku');
                this.handleAddWish(otherSku, response.result.wishId);
              });
            }
          }
          
          this.increase();
          this.sendAlgoliaConversionEventTo(qId, objId);
        } else {
          console.error(response);
        }

      })
    }, error => { console.error(error) })

  },

  handleAddWish(sku, wishId) {
    document.querySelector(`#remove-wish-${sku}`)?.classList.remove('hide');
    document.querySelector(`#add-wish-${sku}`)?.classList.add('hide');
    document.querySelector(`#remove-wish-${sku}`)?.setAttribute('data-wish-id', wishId);
    let matches = document.querySelector(`#remove-wish-${sku}`)?.querySelectorAll(`[data-sku='${sku}']`) || [];

    for (let i = 0; i < matches.length; i++) {
      matches[i].setAttribute('data-wish-id', wishId);
    }
  },

  sendAlgoliaConversionEventTo(qId, objId) {
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;
    const queryID = qId ? qId : searchParams.get('queryId');
    const objectID = objId ? objId : searchParams.get('objectId');
    const userToken = document.getElementById('algoliaUserToken')?.value;

    if(queryID && objectID && userToken) {
      window.aa('convertedObjectIDsAfterSearch', {
        index: 'shopify_products',
        eventName: 'Product Added to Wishlist',
        queryID: queryID,
        objectIDs: [objectID],
        userToken: userToken
      });
    }
  },

  getWishesCount(customerId, customerEmail) {

    if (!customerId || !customerEmail) {
      return;
    }

    this.getTrainzUser(1, customerId, customerEmail).then(x => {
      fetch(`${this.baseUrl}/api/customers/${x.result.customerId}/wishes/count`)
        .then(y => y.json(), reason => console.error(reason))
        .then(countResponse => {
          let content = '';

          if (countResponse.result > 0) {
            content = `Wish List (${countResponse.result})`;
          } else {
            content = `Wish List (0)`;
          }

          document.querySelector('.wish-list-counter').textContent = content;
          document.querySelector('.wish-list-counter').setAttribute('data-wishes-count', countResponse.result);

        }, reason => console.error(reason));

    }, reason => console.error(reason));
  },

  increase() {
    let stringCount = document.querySelector('.wish-list-counter').getAttribute('data-wishes-count');
    let count = stringCount ? parseInt(stringCount) : 0;
    document.querySelector('.wish-list-counter').setAttribute('data-wishes-count', count + 1);
    document.querySelector('.wish-list-counter').textContent = `Wish List (${count + 1})`;
  },

  decrease() {
    let stringCount = document.querySelector('.wish-list-counter').getAttribute('data-wishes-count');
    let count = stringCount ? parseInt(stringCount) : 0;
    document.querySelector('.wish-list-counter').setAttribute('data-wishes-count', count - 1);
    document.querySelector('.wish-list-counter').textContent = `Wish List (${count - 1})`;
  }
};